import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import MaintenancePage from './pages/Maintenance';


// 🔹 Detect subdomain for multi-tenant context
// const hostname = window.location.hostname; // e.g. demo-hotel.wiventory.com
// const subdomain = hostname.split('.')[0];  // e.g. demo-hotel
// console.log("Current tenant:", subdomain);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


const isMaintenance = false;

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      {isMaintenance ? < MaintenancePage /> : <App />}
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

serviceWorkerRegistration.register();